jQuery(document).ready(function ($) {

    setHomeRefPlacement();
    setSidebar();
    addDropdownToMenu();
    sliderResponsive();
    setSearchBar();
    structureCardColumns();
    setIsotopeFilter();

    /***** BACK TO TOP ******/
    $('#backToTop').click(function () {
        $('html, body').animate({scrollTop: 0}, 'slow');
    });
    listenScroll();

    $(window).resize(function () {
        setHomeRefPlacement();
        sliderResponsive();
    });

    $(window).scroll(function () {
        listenScroll();
    });

    function listenScroll() {
        if ($(document).scrollTop() >= 50) {
            $('#backToTop').addClass('backToTop--visible');
        } else {
            $('#backToTop').removeClass('backToTop--visible');
        }
    }

    function setHomeRefPlacement() {
        if ($('.voyCore__homeRef').length === 0) return;

        var height = $('.voyCore__homeRef').innerHeight();
        $('footer').css('margin-bottom', height);
    }

    function setSidebar() {
        var leftSidebarjs = new SidebarJS.SidebarElement({
            component: document.querySelector('#slide-out'),
            documentMinSwipeX: 10,
            documentSwipeRange: 50,
            backdropOpacity: 0.5,
        });
    }

    function addDropdownToMenu() {
        $('.dropdown').each(function () {
            var open = $(this).find('.current_page_item');
            var icon = open.length > 0 ? 'fa-angle-up' : 'fa-angle-down';
            $(this).find('> a').append('<span class="dropdown__toggle"><i class="fas ' + icon + '"></i></span>');
        });

        $('.dropdown__toggle').click(function (e) {
            e.preventDefault();
            $(this).find('i').toggleClass('fa-angle-down fa-angle-up');
            $(this).closest('.dropdown').find('> ul').slideToggle();
            return false;
        });
    }

    /***** searchbar ******/

    function setSearchBar() {
        $('.toggle-search').each(function(index) {
            $(this).on("click", function(){
                $('.header__search').toggleClass('header__search--active');
            });
        });
    }

    /**** Counter animation ****/

    $('.structure-chiffre').each(function () {
        var $this = $(this);
        jQuery({Counter: 0}).animate({Counter: $this.text()}, {
            duration: 1000,
            easing: 'swing',
            step: function () {
                $this.text(Math.ceil(this.Counter));
            }
        });
    });


    /**** Slider ****/

    $('.slider-home').slick({
        dots: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }
        ]
    });
    $('.slider-structure').slick({
        dots: false,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });


    function sliderResponsive() {
        var windowsWidth = $(window).width();
        var sliderWidth = $('.home__slider .home-slide__content').width();
        var margin = parseInt(windowsWidth) - parseInt(sliderWidth)
        var sliderPosition = parseInt(margin) / 2

        if (windowsWidth >= 768) {
            $('.home__slider .home-slide__content').css({
                left: sliderPosition
            })
        } else {
            $('.home__slider .home-slide__content').css({
                left: 0
            })
        }
    }

    /**** Carte listing structures - Gestion du passage sur 2 colonnes ****/

    $(window).resize(function () {
        structureCardColumns();
    });
    
    function structureCardColumns(){
        if(($(window).width() > 575 && $(window).width() < 767) || $(window).width() >= 992){
            var html = "<div class='break'></div>";
            $( ".infos-structure__content" ).each(function( index ) {
                var fieldsCount = $( this ).children('.structure-field').length;
                if(fieldsCount > 5 && $( this ).children('.break').length < 1){
                    $( this ).children('.structure-field:nth-child(4)').after(html);
                }
            });
        }
    }

    /**** Filtre isotope pour le filtrage des événements ****/

    // DropDown
    var dropdownBtn = $('.iso-filter__btn');
    var dropdownBlock = $('.iso-filter__dropdown');
    var dropdownInner = $('.iso-filter__dropdown__inner');

    dropdownBlock.attr('data-height', dropdownInner.outerHeight());

    dropdownBtn.on('click', (e) => {
        e.preventDefault();
        if(!dropdownBtn.hasClass('active')) {
            dropdownBtn.addClass('active');
            dropdownBlock.css('max-height',  dropdownBlock.attr('data-height') + 'px');
        } else {
            dropdownBtn.removeClass('active');
            dropdownBlock.css('max-height', '0');
        }
    });

    // Quick search regex
    var qsRegex;

    // Main function
    function setIsotopeFilter() {
        /* https://codepen.io/crisgon/pen/LaKKrg */
        var $container;
        var filters = [[],[]]; // Empty array to fill with classes and date
        $container = $('.js-events');
        $container.isotope();

        // Final filter function
        /* https://stackoverflow.com/questions/62168581/isotope-combined-multiple-checkbox-and-searchbox-filtering */
        function finalResult() {
            $container.isotope({
                filter: function () {
                    let classesResult = filters[0].join(', ') ? $(this).is(filters[0].join(', ')) : true;
                    let dateResult = $(this).data("startdate") >= filters[1][0] && $(this).data("enddate") <= filters[1][1];
                    let searchResult = qsRegex ? $(this).text().match(qsRegex) : true;
                    if (filters[1].length === 0) {
                        return classesResult && searchResult;
                    } else {
                        return classesResult && dateResult && searchResult;
                    }
                }
            });
        }

        var $isoReset = $('.iso-filter__reset');
        $isoReset.on('click', () => {
            let checkboxes = document.querySelectorAll('.iso-filter__dropdown__inner input[type=checkbox]');
            for(let i=0;i<checkboxes.length;i++) {
                let checkbox = checkboxes[i];
                checkbox.checked = false;
            }
            $('.date-start').datepicker("setDate", new Date());
            $('.date-end').datepicker("setDate", new Date());
            $('.quicksearch').val('');
            qsRegex = "";
            filters = [[],[]];
            $container.isotope();
        });

        // tu as le choix dans la date
        $('.date-start').datepicker({
            weekStart: 1,
            daysOfWeekHighlighted: "6,0",
            autoclose: true,
            todayHighlight: true,
            dateFormat: "d MM yy",
            onSelect: function() {
                filterDate();
            },
        });
        $('.date-start').datepicker("setDate", new Date());

        $('.date-end').datepicker({
            weekStart: 1,
            daysOfWeekHighlighted: "6,0",
            autoclose: true,
            todayHighlight: true,
            dateFormat: "d MM yy",
            onSelect: function() {
                filterDate();
            },
        });
        $('.date-end').datepicker("setDate", new Date());

        function filterDate() {
            var startDate = $('.date-start').datepicker('getDate');
            var endDate = $('.date-end').datepicker('getDate');
            var startConvert = $.datepicker.formatDate('yy-mm-dd', startDate);
            var endConvert = $.datepicker.formatDate('yy-mm-dd', endDate);

            filters[1][0] = startConvert;
            filters[1][1] = endConvert;

            finalResult();
        }

        // use value of search field to filter
        var $quicksearch = $('.quicksearch').keyup( debounce( function() {
            qsRegex = new RegExp( $quicksearch.val(), 'gi' );
            finalResult();
        }, 200 ) );

        // Add checked value to array 0
        function addChecked(index, el) {
            if (!filters[index].includes(el)) {
                filters[index].push(el);
            }
        }

        // Delete unchecked value from array 0
        function deleteUnchecked(index, el) {
            let del = filters[index].indexOf(el);
            filters[index].splice(del, 1);
        }

        // Checkboxes function
        function setCheckboxes() {
            let checkboxes = document.querySelectorAll('.iso-filter__dropdown__inner input[type=checkbox]');
            for(let i=0;i<checkboxes.length;i++) {
                let checkbox = checkboxes[i];
                checkbox.addEventListener('click', (e) => {
                    if(e.target.checked) {
                        addChecked(0, e.target.value);
                    } else {
                        deleteUnchecked(0, e.target.value);
                    }
                    finalResult();
                });
            };
        }

        setCheckboxes();

        // debounce so filtering doesn't happen every millisecond
        function debounce( fn, threshold ) {
            var timeout;
            threshold = threshold || 100;
            return function debounced() {
            clearTimeout( timeout );
            var args = arguments;
            var _this = this;
            function delayed() {
                fn.apply( _this, args );
            }
            timeout = setTimeout( delayed, threshold );
            };
        }
        
    }

});
